import { render, staticRenderFns } from "./CardSection.vue?vue&type=template&id=18fc62ef&scoped=true&"
import script from "./CardSection.vue?vue&type=script&lang=js&"
export * from "./CardSection.vue?vue&type=script&lang=js&"
import style0 from "./CardSection.vue?vue&type=style&index=0&id=18fc62ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc62ef",
  null
  
)

export default component.exports